import { $, $$ } from './utils/querySelector';

export class LoadMoreBandsFactory {
    constructor() {
        $$()('[data-load-more="bands"]').forEach((button) => {
            button.addEventListener('click', () => {
                const container = $()('.ghwp-bands');
                const current = $(container)(
                    'ul.ghwp-image-cards:not(.visible)'
                );
                current && current.classList.add('visible');

                const next = $(container)('ul.ghwp-image-cards:not(.visible)');
                if (!next) {
                    button.remove();
                }
            });
        });
    }
}
